import mod from "-!./Restrictions.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Restrictions.js?vue&type=script&lang=js&external"